import { FooterAnalyticsEnum } from './footer/footer-analytics.enum';
import { HomeAnalyticsEnum } from './home/home-analytics.enum';
import { BlogAnalyticsEnum } from './blog/blog-analytics.enum';
import { GenericAnalyticsEnum } from './generic/generic-analytics.enum';
import { BranchAnalyticsEnum } from './entities/branch-analytics.enum';
import { PartnerAnalyticsEnum } from './entities/partner-analytics.enum';
import { ProfessionalsAnalyticsEnum } from './entities/professionals-analytics.enum';
import { SpecialtyAnalyticsEnum } from './entities/speciality-analytics.enum';
import { LaboratoryAnalyticsEnum } from './entities/laboratory-analytics.enum';
import { ExamAnalyticsEnum } from './entities/exam-analytics.enum';
import { CityAnalyticsEnum } from './entities/city-analytics.enum';
import { LocationAnalyticsEnum } from './location/location-analytics.enum';
import { BranchCardAnalyticsEnum } from './entities/branch-card.analytics.enum';
import { MyAppointmentsAnalyticsEnum } from './my-appointments/my-appointments-analytics.enum';
import { DependentsAnalyticsEnum } from './dependents/dependents-analytics.enum';
import { ProfileAnalyticsEnum } from './profile/profile-analytics.enum';
import { FavoritesAnalyticsEnum } from './favorites/favorites-analytics.enum';
import { LoginAnalyticsEnum } from './login/login-analytics.enum';
import { SearchAnalyticsEnum } from './search/search-analytics.enum';
import { CartAnalyticsEnum } from './cart/cart-analytics.enum';
import { PatientSelectionAnalyticsEnum } from './patient-selection/patient-selection-analytics.enum';
import { AnalyticsEventName } from './analytics-domain.type';

export const AnalyticsEnum = {
  ...HomeAnalyticsEnum,
  ...FooterAnalyticsEnum,
  ...BlogAnalyticsEnum,
  ...GenericAnalyticsEnum,
  ...BranchAnalyticsEnum,
  ...BranchCardAnalyticsEnum,
  ...PartnerAnalyticsEnum,
  ...ProfessionalsAnalyticsEnum,
  ...SpecialtyAnalyticsEnum,
  ...LaboratoryAnalyticsEnum,
  ...ExamAnalyticsEnum,
  ...CityAnalyticsEnum,
  ...LocationAnalyticsEnum,
  ...MyAppointmentsAnalyticsEnum,
  ...DependentsAnalyticsEnum,
  ...ProfileAnalyticsEnum,
  ...FavoritesAnalyticsEnum,
  ...LoginAnalyticsEnum,
  ...SearchAnalyticsEnum,
  ...CartAnalyticsEnum,
  ...PatientSelectionAnalyticsEnum,
} as const satisfies Record<string, AnalyticsEventName>;

export type AnalyticsEnumKeyType = (typeof AnalyticsEnum)[keyof typeof AnalyticsEnum];
